<template>
    <FormControl
        :label="customField.title"
        :required="customField.isRequired"
        :error="
            errors.getValidationErrorUsingRawString(`${customField.id.value}`)
        "
    >
        <template
            v-if="
                Array.isArray(savedValue.response) ||
                savedValue.response === null
            "
        >
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CUSTOM_FIELD_ID_KEY}]`"
                :value="customField.id.value"
            />
            <div class="space-y-2">
                <div
                    v-for="option in localSettings.data.multipleCheckboxOptions"
                >
                    <CheckboxInput
                        :label="option"
                        :useBookingFormThemeCssVariables="true"
                        :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}][]`"
                        :checked="savedValue.response?.includes(option)"
                        :value="option"
                        :required="
                            customField.isRequired &&
                            selectedOptions.length === 0
                        "
                        @input="
                            handleCheckboxStateChanged($event?.target?.value)
                        "
                    />
                </div>
            </div>
        </template>
        <template v-else>
            <UnexpectedError />
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import {
        RAW_RESPONSE_CONTENT_KEY,
        RAW_RESPONSE_CUSTOM_FIELD_ID_KEY,
        type CustomFieldResponseDTO,
        type CustomFieldSettingsMultipleCheckboxType,
    } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import UnexpectedError from '@/BookingForm/BookingForm/Component/CustomField/UnexpectedError.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    const localSettings: CustomFieldSettingsMultipleCheckboxType =
        props.customField.settings
    const initialOptions = Array.isArray(props.savedValue?.response)
        ? props.savedValue?.response
        : []
    const selectedOptions = ref<string[]>(initialOptions)

    const handleCheckboxStateChanged = (value: any): void => {
        if (!value) {
            throw new Error('Value should not be null', { cause: value })
        }

        if (selectedOptions.value.includes(value)) {
            selectedOptions.value = selectedOptions.value.filter(
                (currentValue: string) => {
                    return currentValue !== value
                },
            )
        } else {
            selectedOptions.value.push(value)
        }
    }
</script>
